import Tr from 'translations/Translations';

const createItem = (trKey, value = Tr(trKey)) => ({
    label: Tr(trKey),
    value,
})

export const TRUE_FALSE_VALUE = {
    TRUE: 'true',
    FALSE: 'false'
}

export default [
    createItem('yes', TRUE_FALSE_VALUE.TRUE),
    createItem('no', TRUE_FALSE_VALUE.FALSE)
]

export const TrueFalseWithEmpty = [
    createItem('not_specified', '_'),
    createItem('yes', TRUE_FALSE_VALUE.TRUE),
    createItem('no', TRUE_FALSE_VALUE.FALSE)
]